import { IGeoCodedSearchDetails } from '../../../types/geocode';

export const getDisplayName = (lastListItem: IGeoCodedSearchDetails | null, baseName: string) => {
  if (lastListItem?.geoType === 'House') {
    return baseName;
  }

  return lastListItem && lastListItem.fullName ? lastListItem.fullName : baseName;
};
